<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Add Calibration Technician</h5>
      <button type="button"  (click)="openModal_Customer(templatePersone)" class="btn btn-warning" style="margin-right: 5px;"> Search Personnel  <i class="fa fa-user"></i> </button>

      <br>
      <br>
      <form *ngIf="selected_DataList_Persone_Record.id>0" [formGroup]="AddNewExpertCalibration" (submit)="SubmitAddNewExpertCalibration()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Activity Location  </label>
            <select formControlName="Area_Type" class="custom-select">
              <option value="0">Select</option>
              <option value="1">Inside the Laboratory</option>
              <option value="2">Outside the Laboratory</option>
              <option value="3">Inside/Outside the Laboratory</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Responsibility</label>
            <input formControlName="Response" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Response().valid && get_Form_Response().touched" class="form-text text-muted MyErrorRedColor">Enter the responsibility.</small>
          </div>
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1">Description</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="Type here...">
          </div>
        </div>

          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewExpertCalibration.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
          <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-right: 5px;"><i class="fa fa-times-rectangle" ></i> Cancel </button>
          <button routerLink="/ExpertCalibration" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
      <button routerLink="/ExpertCalibration" *ngIf="selected_DataList_Persone_Record.id==0" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
  </div>
</div>


<ng-template #templatePersone>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Personnel List</h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Person.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> Name/Last Name </label>
            <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text" class="form-control"  placeholder="Type here to search...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Full Name</th>
              <th>Abbreviation in Behineh Farayand Azma</th>
              <th>National ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Persone
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Persone|filter:Filter_title:'fullname').length
                      }
            ">
            <td>{{DataList_Persone.indexOf(item)+1}}</td>
            <td>{{item.fullname}}</td>
            <td>{{item.almat_Ekhtesari}}</td>
            <td>{{item.codemeli}}</td>

              <td (click)="selected_DataList_Persone(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> Select</button>
              </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>
 </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingPersone" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!ProcssingPersone" type="button" (click)="ReadData_Persone()"  class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Person.hide()">Close</button>
  </div>
</ng-template>
